import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { Store } from '@ngxs/store';
import { map } from 'rxjs/operators';
import { CountriesState } from '@nibtravel/shared/data-access/countries';
import {
  AutocompleteComponent,
  AutocompleteValueSelectEvent,
} from '@nibtravel/shared/ui/forms/autocomplete';
import { BehaviorSubject } from 'rxjs';

const popularRegions: Array<{
  name: string;
  countryCodes: string[];
}> = [
  {
    name: 'Americas',
    countryCodes: ['USA', 'CAN'],
  },
  {
    name: 'Asia',
    countryCodes: ['THA', 'BAL', 'VNM', 'IDN', 'MYS', 'HKG', 'JPN'],
  },
  {
    name: 'Europe',
    countryCodes: ['GBR', 'FRA', 'DEU', 'ITA', 'ESP'],
  },
  {
    name: 'Pacific',
    countryCodes: ['AUS', 'NZL', 'FJI', 'VUT'],
  },
  {
    name: 'Africa',
    countryCodes: ['ZAF'],
  },
  {
    name: 'Cruising',
    countryCodes: ['AUW', 'SPC', 'MED', 'EUC', 'CAR', 'ALI', 'WWD'],
  },
];

@Component({
  selector: 'nibtravel-qqc-country-suggestions',
  templateUrl: './popularCountrySuggestions.component.html',
})
export class PopularCountrySuggestionsComponent {
  @Input() nibtravelAutocomplete?: AutocompleteComponent;

  constructor(private store: Store) {}

  @ViewChild('root')
  rootTemplate!: ElementRef<any>;

  popularDestinations$ = this.store
    .select(CountriesState.destinationCountriesList)
    .pipe(
      map((countries) =>
        popularRegions.map((r) => ({
          name: r.name,
          countries: r.countryCodes
            .map((code) => countries.find((c) => c.code === code))
            .filter((x) => !!x)
            .map((c) => {
              return {
                option: {
                  text: c?.name,
                  value: c?.code,
                  id: c?.code,
                  aliases: c?.aliases,
                },
              };
            }),
        }))
      )
    );

  private onClickHandler(country: AutocompleteValueSelectEvent) {
    this.nibtravelAutocomplete?.onOptionSelected(country);
    this.nibtravelAutocomplete?.changeDestinationSuggestion(false);
  }
}
